exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-header {\r\n    display: flow-root;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/admin/Documents/Visual Studio 2017/Projects/VanzAngularEcommerce/src/app/pages/checkout/checkout-modal/checkout-modal.component.css
// module id = ../../../../../src/app/pages/checkout/checkout-modal/checkout-modal.component.css
// module chunks = 1